interface PointsBadgeProps {
  points: number;
  size?: "sm" | "md" | "lg";
}

// Soft pastel tone per effort level (1–5), with dark-mode variants
const COLORS: Record<number, string> = {
  1: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
  2: "bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300",
  3: "bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300",
  4: "bg-orange-100 text-orange-700 dark:bg-orange-500/15 dark:text-orange-300",
  5: "bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300",
};

const SIZES = {
  sm: "min-w-7 h-7 text-xs",
  md: "min-w-8 h-8 text-sm",
  lg: "min-w-12 h-12 text-lg",
};

export function PointsBadge({ points, size = "md" }: PointsBadgeProps) {
  const tone = COLORS[Math.min(Math.max(points, 1), 5)] ?? COLORS[5];
  return (
    <div
      className={`${SIZES[size]} ${tone} px-1.5 rounded-full inline-flex items-center justify-center font-extrabold tabular-nums`}
      aria-label={`${points} point${points === 1 ? "" : "s"}`}
      title={`${points} point${points === 1 ? "" : "s"}`}
    >
      {points}
    </div>
  );
}

export default PointsBadge;
